import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import api from "../lib/api";
import { useAuth, authHeaders } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAGES = new Set(["/dashboard", "/scanner", "/comparateur", "/opportunities", "/watchlist", "/spin", "/produits-500", "/fournisseurs-300", "/produits-marketplaces", "/calculateur-douane", "/notifications", "/subscription", "/affiliation", "/contact", "/blog"]);

export default function UsagePresence() {
  const { user, checkAuth } = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    const clients = [axios, api];
    const ids = clients.map(client => client.interceptors.request.use(config => {
      // Attach only the existing access token to this app's API, preserving admin/refresh headers.
      try {
        const target = new URL(config.url, config.baseURL || window.location.origin);
        const backend = new URL(API, window.location.origin);
        if (target.origin === backend.origin && target.pathname.startsWith("/api/") &&
            !target.pathname.startsWith("/api/admin/") && !config.headers.Authorization) {
          const token = localStorage.getItem("profimy_access_token");
          if (token) config.headers.Authorization = `Bearer ${token}`;
        }
      } catch { /* Leave non-app requests unchanged. */ }
      return config;
    }));
    return () => clients.forEach((client, i) => client.interceptors.request.eject(ids[i]));
  }, []);
  useEffect(() => {
    if (!user || user.role === "admin" || !PAGES.has(pathname)) return;
    let busy = false;
    let disposed = false;
    const track = async () => {
      if (busy || disposed || document.visibilityState !== "visible") return;
      busy = true;
      try {
        await axios.post(`${API}/usage/presence`, null, { params: { page: pathname }, headers: authHeaders() });
      } catch (error) {
        if (error.response?.status === 401 && !disposed) await checkAuth();
      } finally { busy = false; }
    };
    track();
    const interval = setInterval(track, 60000);
    document.addEventListener("visibilitychange", track);
    return () => {
      disposed = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", track);
    };
  }, [user, pathname, checkAuth]);
  return null;
}
